// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pps-callback__title{color:#a6a6a6;margin-bottom:24px}.pps-callback__info{display:flex}.pps-callback__info+a{margin-top:8px}.pps-callback__info a{align-items:center;display:flex;margin-right:8px}.pps-callback__info a svg{margin-right:8px}.pps-callback__mail{display:block;margin-bottom:26px}.pps-callback>.button{margin-top:24px;max-width:162px}@media screen and (max-width:750px){.pps-callback>.button{max-width:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
